export class ResetUserPassword {

  
    nouveau_mot_de_passe?: any="";
    confirm_nouveau_mot_de_passe?: any="";
    email?: any="";
    token ?: any="";
    user_reference  ?: any="";
   
  
  
    private errorMessage: string;
  
    constructor(){
      this.errorMessage = "";
    }
    
    //get error message
    getErrorMessage(): string {
      return this.errorMessage;
    }//end getErrorMessage
    
    //check for save
    canSave(): boolean {
    
      //nom

      if(this.nouveau_mot_de_passe === undefined || this.nouveau_mot_de_passe === null || this.nouveau_mot_de_passe.trim() === ""){
        this.errorMessage = "Veuillez saisir le nouveau mot de passe"; return false;
      }


      if(this.confirm_nouveau_mot_de_passe === undefined || this.confirm_nouveau_mot_de_passe === null || this.confirm_nouveau_mot_de_passe.trim() === ""){
        this.errorMessage = "Veuillez confirmer le nouveau mot de passe"; return false;
      }
    
    
      if (this.nouveau_mot_de_passe !== this.confirm_nouveau_mot_de_passe) {
        this.errorMessage = "Le mot de passe et le  mot de passe de confirmation ne correspondent pas";
        return false;
      }
      
      return true;


    }//end canSave

    
  
  
    
   
    
   
  }